// components/ConsentModal.js
import React, { useState } from 'react';
import { Box, Button, Checkbox, FormControlLabel, Typography, Modal } from '@mui/material';
import { Link } from 'react-router-dom';

const ConsentModal = ({ open, onAccept, onCancel }) => {
    const [accepted, setAccepted] = useState(false);

    return (
        <Modal open={open} onClose={onCancel}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    maxWidth: 500,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h6" gutterBottom>
                    Accept Our Policies
                </Typography>
                <Typography variant="body1" paragraph>
                    Before proceeding, please review and accept our{' '}
                    <Link to="/privacy-policy" target="_blank">
                        Privacy Policy
                    </Link>{' '}
                    and{' '}
                    <Link to="/privacy-policy" target="_blank">
                        Terms of Service
                    </Link>.
                </Typography>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={accepted}
                            onChange={(e) => setAccepted(e.target.checked)}
                        />
                    }
                    label="I have read and agree to the Privacy Policy and Terms of Service."
                />
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="outlined"
                        onClick={onCancel}
                        sx={{ mr: 2 }}
                        disabled={!accepted}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onAccept}
                        disabled={!accepted}
                    >
                        Accept
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ConsentModal;